import React from 'react';
import { ListFieldSection } from '../../../../Layout';
import { Field, TextOutput } from '../../../../Core';
import { WorksheetsResultsMessagesSection } from '../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';

let ResultsSectionContent = () => {
  return (
    <ListFieldSection>
      <Field label="Group Code" input={<TextOutput />} name="Results.GroupCode" />
      <Field label="Group Name" input={<TextOutput />} name="Results.GroupName" />
    </ListFieldSection>
  );
};
ResultsSectionContent = withInjectedProps(ResultsSectionContent);

let ResultsSection = () => (
  <>
    <WorksheetsResultsMessagesSection />
    <ResultsSectionContent />
  </>
);

ResultsSection = withInjectedProps(ResultsSection);

export { ResultsSection, ResultsSectionContent };
export default ResultsSection;
